module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens2-1689dfc13faa3b2755b84397b95d46a2.jpg";